import React from "react";
import { connect } from "react-redux";
import { preguntas } from "../properties";
import { movil } from "../app-movil";

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		setP1: (obj) => {
			dispatch({ "type": "MI_PERFIL_SET_P1", "p": obj.p, "id": obj.id });
		},
		setP2: (obj) => {
			dispatch({ "type": "MI_PERFIL_SET_P2", "p": obj.p, "id": obj.id });
		},
		pasoSiguienteContrasena: () => {
			dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_CONTRASENA" });
		},
		resetSiguienteContrasena: () => {
			dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA" });
		},
		guardarPassword: (pass) => {
			dispatch({ "type": "MI_PERFIL_SET_NEWPASS", "newPass":  pass });
		},
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class PasoUnoContrasena extends React.Component {
	state = {
		inputClassPassOld: "input-wrap ver-input",
		inputClassPassNew: "input-wrap ver-input",
		inputClassPassNewConf: "input-wrap ver-input",
		inputPassOldType: "password",
		inputPassNewType: "password",
		inputPassNewConfType: "password",
		inputActivePassOld: "",
		inputActivePassNew: "",
		inputActivePassNewConf: "",
		errorOldPass: false,
		errorNewPass: false,
		errorConfPass: false,
		errorMsjOldPass: "",
		errorMsjNewPass: "",
		errorMsjConfPass: "",
	}

	componentWillMount = () => {
		/*this.refs.ipo.value = "";
		this.refs.ipn.value = "";
		this.refs.ipnc.value = "";*/
	}

	handleFocus = (event) => {
		let id = event.target.id;
		switch(id) {
		case "inputPassOld":
			this.setState({inputActivePassOld: "input-active"});
			this.setState({errorOldPass: false});
			this.setState({errorMsjOldPass: ""});
			break;
		case "inputPassNew":
			this.setState({inputActivePassNew: "input-active"});
			this.setState({errorNewPass: false});
			this.setState({errorMsjNewPass: ""});
			this.verify(event);
			break;
		case "inputPassNewConf":
			this.setState({inputActivePassNewConf: "input-active"});
			this.setState({errorConfPass: false});
			this.setState({errorMsjConfPass: ""});
			this.verify(event);
			break;
		}
	}
	handleBlur = (event) => {
		let id = event.target.id;
		let valor = event.target.value;
		switch(id) {
		case "inputPassOld":
			this.setState({inputActivePassOld: valor ? "input-active" : ""});
			this.setState({oldPass: valor});
			break;
		case "inputPassNew":
			this.setState({inputActivePassNew: valor ? "input-active" : ""});
			this.setState({newPass: valor});
			this.verify(event);
			break;
		case "inputPassNewConf":
			this.setState({inputActivePassNewConf: valor ? "input-active" : ""});
			this.setState({confPass: valor});
			this.verify(event);
			break;
		}
	}
	toggleType = (event) => {
		let id = event.target.id;
		let type;
		switch(id) {
		case "ojoPassOld":
			type = this.state.inputPassOldType;
			this.setState({inputPassOldType: type == "password" ? "text" : "password"});
			this.setState({inputClassPassOld: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
			break;
		case "ojoPassNew":
			type = this.state.inputPassNewType;
			this.setState({inputPassNewType: type == "password" ? "text" : "password"});
			this.setState({inputClassPassNew: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
			break;
		case "ojoPassNewConf":
			type = this.state.inputPassNewConfType;
			this.setState({inputPassNewConfType: type == "password" ? "text" : "password"});
			this.setState({inputClassPassNewConf: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
			break;
		}
	}
	checkPass = () => {
		//let oldPass = this.state.oldPass;
		let newPass = this.state.newPass;
		let confPass = this.state.confPass;
		let ok = true;
	   /* if(!oldPass) {
			this.setState({errorOldPass: true});
			this.setState({errorMsjOldPass: "Campo requerido."});
			ok = false;
		}*/
		if(!newPass || !confPass){
			this.props.tagManager({ "type": "EVENT_PERFIL_CONTRASEÑA-VACIOS", "dispositivo": this.props.dispositivo });
		}
		if(!newPass) {
			this.setState({errorNewPass: true});
			this.setState({errorMsjNewPass: "Campo requerido."});
			this.props.addEvento("CampoRequerido-ModContraseña");
			ok = false;
		}
		if(!confPass) {
			this.setState({errorConfPass: true});
			this.setState({errorMsjConfPass: "Campo requerido."});
			this.props.addEvento("CampoRequerido-ModContraseña");
			ok = false;
		}
		if(newPass && confPass && newPass != confPass) {
			this.setState({errorConfPass: true});
			this.setState({errorMsjConfPass: "Tus contraseñas no coinciden. Favor de verificar."});
			ok = false;
		}
		if(!this.state.errorNewPass && !this.state.errorConfPass && ok) {
			movil("enviarToken",{"proceso":"enviarToken","return":"no"});
			this.props.guardarPassword(newPass);
			this.props.pasoSiguienteContrasena();
		}
	}
	okContrasena = () => {
		let mensaje = {"return": "miPerfil", "proceso": "cambioContrasena"};
		movil("cambioContrasena", mensaje);
		this.props.resetSiguienteContrasena();
		this.setState({inputClassPassOld: "input-wrap ver-input"});
		this.setState({inputClassPassNew: "input-wrap ver-input"});
		this.setState({inputClassPassNewConf: "input-wrap ver-input"});
		this.setState({inputClassPreguntaPass: "input-wrap ver-input"});
		this.setState({inputActivePassOld: ""});
		this.setState({inputActivePassNew: ""});
		this.setState({inputActivePassNewConf: ""});
		this.setState({inputActivePreguntaPass: ""});
		this.setState({inputPassOldType: "password"});
		this.setState({inputPassNewType: "password"});
		this.setState({inputPassNewConfType: "password"});
		this.setState({inputPreguntaPassType: "password"});
		this.setState({oldPass: ""});
		this.setState({newPass: ""});
		this.setState({confPass: ""});
		this.setState({errorPregunta: false});
		this.setState({errorPreguntaContrasena: false});
		this.setState({intentoPregunta: 1});
		this.setState({errorOldPass: false});
		this.setState({errorNewPass: false});
		this.setState({errorConfPass: false});
		this.setState({preguntaCambiarContrasena: ""});
		this.setState({errorMsjPreguntaContrasena: ""});
		this.setState({respuestaCambiarContrasena: ""});
		//this.refs.ipo.value = "";
		this.refs.ipn.value = "";
		this.refs.ipnc.value = "";
		$("#modal-editar-contrasena").modal('toggle');
		this.props.addEvento("Cancelar-ModContraseña");
	}
	verify = (event) => {
		function checkMayus(str) {
				return str.toLowerCase() != str;
		}
		let valor = event.target.value;
		let id = event.target.id;
		var a = 0;
		var regexpr2 = /([\w])\1{2,}/;
		//var regexprAlfaNumerico = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
		var NUMEROS = "0123456789";
		var ABC = "abcdefghijklmnopqrstuvwxyz";
		let ok = true;
		var regexpr= /\s+/;
		if(id == "inputPassNew") {
			if (valor.length == 0){
				ok = false;
				this.setState({errorNewPass: true});
				this.setState({errorMsjNewPass: "Campo requerido."});
			} else if (valor.length <= 7) {
				ok = false;
				this.setState({errorNewPass: true});
				this.setState({errorMsjNewPass: "Debe ser al menos de 8 posiciones."});
			} else if(regexpr.test(valor)) {
				ok = false;
				this.setState({errorNewPass: true});
				this.setState({errorMsjNewPass: "No se admiten espacios en blanco."});
			} else if(valor.toLowerCase().includes("gnp")) {
				ok = false;
				this.setState({errorNewPass: true});
				this.setState({errorMsjNewPass: "No debe contener la palabra GNP."});
			} else if (isNaN(valor) == false) {
				ok = false;
				this.setState({errorNewPass: true});
				this.setState({errorMsjNewPass: "Debe incluir caracteres alfabéticos."});
			} else if (/[0-9]/.test(valor) == false) {
				ok = false;
				this.setState({errorNewPass: true});
				this.setState({errorMsjNewPass: "Debe contener al menos un carácter numérico."});
			} else if(regexpr2.test(valor)) {
				ok = false;
				this.setState({errorNewPass: true});
				this.setState({errorMsjNewPass: "No debe contener más de dos caracteres iguales de forma consecutiva (p.e. 222, eee)."});
			}	else if(checkMayus(valor) == false) {
				ok = false;
				this.setState({errorNewPass: true});
				this.setState({errorMsjNewPass: "Debe de contener al menos una mayúscula."});
				}  else {
				for( var i = 0; i < valor.length; i++) {
					var cadena = valor.substr(i,3).toLowerCase();
					if(cadena.length == 3 && (ABC.indexOf(cadena) >= 0 || NUMEROS.indexOf(cadena) >= 0)) {
						ok = false;
						this.setState({errorNewPass: true});
						this.setState({errorMsjNewPass: "No debe contener más de dos caracteres numéricos o alfabéticos de forma consecutiva (p.e. 123, abc)."});
						break;
					}
					/*if(NUMEROS.indexOf(valor[i].toLowerCase()) < 0 && ABC.indexOf(valor[i].toLowerCase()) < 0){
						ok = false;
						this.setState({errorNewPass: true});
						this.setState({errorMsjNewPass: "No debe contener caracteres especiales ni ñ (*,#,&,%,etc)"});
						break;
					}
					if (i >= 2 && i <= valor.length) {
						var cad = valor.substr(a, 3).toLowerCase();
						if (NUMEROS.indexOf(cad) >= 0 || ABC.indexOf(cad) >= 0) {
							ok = false;
							this.setState({errorNewPass: true});
							this.setState({errorMsjNewPass: "No debe contener más de dos caracteres numéricos o alfabéticos de forma consecutiva (p.e. 123, abc)."});
							break;
						}
						a++;
					}*/
				}
			}
			if(ok) {
				this.setState({errorNewPass: false});
				this.setState({errorMsjNewPass: ""});
			}
		} else {
			if(valor && valor != this.refs.ipn.value) {
				this.setState({errorConfPass: true});
				this.setState({errorMsjConfPass: "Tus contraseñas no coinciden. Favor de verificar."});
			} else {
				this.setState({errorConfPass: false});
				this.setState({errorMsjConfPass: ""});
			}
		}
	}

	render() {
		return <div>
			<h5>
				<i>
					<img src={ require("../img/delete-pass.png") } />
				</i>Modificar contraseña
			</h5>
			<hr className="mt-34" />
			<p className="blue-text texto-12">Para tu nueva contraseña contempla que:</p>
			<p className="texto-12">- Debe ser de al menos de 8 posiciones, incluyendo caracteres alfanuméricos.</p>
			<p className="texto-12">- No debe contener la palabra GNP.</p>
			<p className="texto-12">- No debe contener más de dos caracteres iguales de manera consecutiva (p.e. 222, eee).</p>
			<p className="texto-12">- No debe tener más de dos caracteres consecutivos numéricos o alfabéticos (p.e. 123, abc).</p>
			<p className="texto-12 mb-20">- Debe incluir al menos una letra mayúscula, una letra minúscula y un número.</p>
			<div className="row mt-25">
				<div className="col-xs-12 col-md-10 col-md-offset-1">
					<div className="row">
						<div className="col-xs-12 col-md-6">
							<div className={this.state.inputClassPassNew}>
								<label>Nueva contraseña</label>
								<span className={this.state.inputActivePassNew}>
									<input ref="ipn" maxLength="24" id="inputPassNew" type={this.state.inputPassNewType} onFocus={this.handleFocus} onBlur={this.handleBlur} onChange={this.verify} />
									<div id="ojoPassNew" className="btn-ojo" onClick={this.toggleType}></div>
								</span>
								{ this.state.errorNewPass &&
									<div className="error-wrap">
										<div className="msj-error">
											<p>{this.state.errorMsjNewPass}</p>
										</div>
									</div>
								}
							</div>
						</div>
						<div className="col-xs-12 col-md-6">
							<div className={this.state.inputClassPassNewConf}>
								<label>Confirmar nueva contraseña</label>
								<span className={this.state.inputActivePassNewConf}>
									<input ref="ipnc" maxLength="24" id="inputPassNewConf" type={this.state.inputPassNewConfType} onFocus={this.handleFocus} onBlur={this.handleBlur} onChange={this.verify} />
									 <div id="ojoPassNewConf" className="btn-ojo" onClick={this.toggleType}></div>
								</span>
								{ this.state.errorConfPass &&
									<div className="error-wrap">
										<div className="msj-error">
											<p>{this.state.errorMsjConfPass}</p>
										</div>
									</div>
								}
							</div>
						</div>
						<div className="col-xs-12">
							<div className="text-center aceptar-cancelar-btn">
								<a onClick={this.okContrasena}>Cancelar</a>
								<a className="orange-btn" onClick={this.checkPass}>Aceptar</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(PasoUnoContrasena);



// WEBPACK FOOTER //
// ./src/miPerfil/pasoUnoContrasena.cmpt.js